import * as type from './mutation-types'
export const state = {
    status: -9999,
    errmsg: '',
    userInfo: {},
    loading: '',
    userDrInfo: {},
    drLoading: '',
    curGearInfo: {},
    cgLoading: '',
    payModeInfo: {},
    pmLoading: '',
    iapInfo: {},
    iapLoading: '',
    orderInfo: {},
    orderLoading: '',
    orderData: {},
    orderStatus: '',
    orderVerifyData: {},
    ovStatus: '',
    reqData: {},
    reqStatus: '',
    goodsDetail: {},
    gdLoading: '',
    dpList: {},
    dpLoading: '',
    cRoleList: {},
    crLoading: '',
    subList: {},
    subLoading: '',
    uname: '',
    pointData: {},
    upLoading: '',
    pointRule: {},
    urLoading: '',
    pointSwitch: {},
    uwLoading: '',
    codeData: {},
    codeStatus: '',
    setEmailData: {},
    seStatus: '',
    pointInit: {},
    piLoading: '',
    pwdFlag: {},
    pfLoading: '',
    emailFlag: {},
    efLoading: '',
    pwdData: {},
    psStatus: '',
    cPwdData: {},
    cpStatus: '',
    peData: {},
    peStatus: '',
    checkData: {},
    checkStatus: '',
    checkUPData: {},
    checkUPStatus: '',
    cpeData: {},
    cpeLoading: '',
    versionData: {},
    vLoading: '',
    showPage: false,
    // center 模块 ParamTrackerCtrl 
    trackLogInfo: {},
    trackLogStatus: '',
}
export function getCookiesObj() { 
    return document.cookie.split(';').reduce((f, sv) => {
        let _sv = sv.trim().split('=').map(v => {
            return v.trim()
        })
        f[_sv[0]] = _sv[1]   
        return f  
    }, {})
}
export const mutations = {
    [type.ERROR_RECEIVE](state, res) {},
    [type.INIT](state, res) {
        res.uname && (state.uname = res.uname)
        res.showPage && (state.showPage = res.showPage)
    },

    [type.CHECKPAYEMAIL_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.cpeData = {}
        state.cpeLoading = 'loading'
    },
    [type.CHECKPAYEMAIL_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.cpeData = (res && res.content) || {}
        state.cpeLoading = state.status > -9999 && 'loaded'
    },

    [type.GETUSERPOINTDATA_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pointData = {}
        state.upLoading = 'loading'
    },
    [type.GETUSERPOINTDATA_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pointData = (res && res.content) || {}
        state.upLoading = state.status > -9999 && 'loaded'
    },

    [type.GETUSERPOINTRULE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pointRule = {}
        state.urLoading = 'loading'
    },
    [type.GETUSERPOINTRULE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pointRule = (res && res.content) || {}
        state.urLoading = state.status > -9999 && 'loaded'
    },

    [type.GETUSERPOINTSWITCH_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pointSwitch = {}
        state.uwLoading = 'loading'
    },
    [type.GETUSERPOINTSWITCH_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pointSwitch = (res && res.content) || {}
        state.uwLoading = state.status > -9999 && 'loaded'
    },

    [type.ORDERSUBLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.subList = {}
        state.subLoading = 'loading'
    },
    [type.ORDERSUBLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.subList = (res && res.content) || {}
        state.subLoading = state.status > -9999 && 'loaded'
    },

    [type.CHECKROLESTOKEN_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.cRoleList = {}
        state.crLoading = 'loading'
    },
    [type.CHECKROLESTOKEN_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.cRoleList = (res && res.content) || {}
        state.crLoading = state.status > -9999 && 'loaded'
    },

    [type.GETDEFAULTPAYMENT_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.dpList = {}
        state.dpLoading = 'loading'
    },
    [type.GETDEFAULTPAYMENT_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.dpList = (res && res.content) || {}
        state.dpLoading = state.status > -9999 && 'loaded'
    },

    [type.THIRDPAYLOGIN_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.userInfo = {}
        state.loading = 'loading'
    },
    [type.THIRDPAYLOGIN_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.userInfo = (res && res.content) || {}
        state.loading = state.status > -9999 && 'loaded'
    },

    [type.THIRDPAYDRLOGIN_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.userDrInfo = {}
        state.drLoading = 'loading'
    },
    [type.THIRDPAYDRLOGIN_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.userDrInfo = (res && res.content) || {}
        state.drLoading = state.status > -9999 && 'loaded'
    },

    [type.GETCURRENCYGEAR_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.curGearInfo = {}
        state.cgLoading = 'loading'
    },
    [type.GETCURRENCYGEAR_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.curGearInfo = (res && res.content) || {}
        state.cgLoading = state.status > -9999 && 'loaded'
    },

    [type.GETALLPAYMODE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.payModeInfo = {}
        state.pmLoading = 'loading'
    },
    [type.GETALLPAYMODE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.payModeInfo = (res && res.content) || {}
        state.pmLoading = state.status > -9999 && 'loaded'
    },

    [type.SERVERIAPLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.iapInfo = {}
        state.iapLoading = 'loading'
    },
    [type.SERVERIAPLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.iapInfo = (res && res.content) || {}
        state.iapLoading = state.status > -9999 && 'loaded'
    },

    [type.GETTHIRDPAYORDERLIST_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.orderInfo = {}
        state.orderLoading = 'loading'
    },
    [type.GETTHIRDPAYORDERLIST_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.orderInfo = (res && res.content) || {}
        state.orderLoading = state.status > -9999 && 'loaded'
    },

    [type.CREATETHIRDPAYORDER_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.orderData = {}
        state.orderStatus = 'stating'
    },
    [type.CREATETHIRDPAYORDER_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.orderData = (res && res.content) || {}
        state.orderStatus = state.status > -9999 && 'stated'
    },

    [type.VERIFYTHIRDPAYORDER_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.orderVerifyData = {}
        state.ovStatus = 'stating'
    },
    [type.VERIFYTHIRDPAYORDER_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.orderVerifyData = (res && res.content) || {}
        state.ovStatus = state.status > -9999 && 'stated'
    },

    [type.THIRDPAYORDERREQUESTPAY_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.reqData = {}
        state.reqStatus = 'stating'
    },
    [type.THIRDPAYORDERREQUESTPAY_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.reqData = (res && res.content) || {}
        state.reqStatus = state.status > -9999 && 'stated'
    },

    [type.GETTHIRDPAYGOODSDETAIL_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.goodsDetail = {}
        state.gdLoading = 'loading'
    },
    [type.GETTHIRDPAYGOODSDETAIL_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.goodsDetail = (res && res.content) || {}
        state.gdLoading = state.status > -9999 && 'loaded'
    },

    [type.GETEMAILCODE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.codeData = {}
        state.codeStatus = 'stating'
    },
    [type.GETEMAILCODE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.codeData = (res && res.content) || {}
        state.codeStatus = state.status > -9999 && 'stated'
    },

    [type.SETPAYEMAIL_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.setEmailData = {}
        state.seStatus = 'stating'
    },
    [type.SETPAYEMAIL_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.setEmailData = (res && res.content) || {}
        state.seStatus = state.status > -9999 && 'stated'
    },

    [type.GETPOINTINIT_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pointInit = {}
        state.piLoading = 'loading'
    },
    [type.GETPOINTINIT_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pointInit = (res && res.content) || {}
        state.piLoading = state.status > -9999 && 'loaded'
    },

    [type.GETPAYPWDFLAG_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pwdFlag = {}
        state.pfLoading = 'loading'
    },
    [type.GETPAYPWDFLAG_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pwdFlag = (res && res.content) || {}
        state.pfLoading = state.status > -9999 && 'loaded'
    },

    [type.GETEMAILFLAG_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.emailFlag = {}
        state.efLoading = 'loading'
    },
    [type.GETEMAILFLAG_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.emailFlag = (res && res.content) || {}
        state.efLoading = state.status > -9999 && 'loaded'
    },

    [type.SETPAYPWD_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.pwdData = {}
        state.psStatus = 'stating'
    },
    [type.SETPAYPWD_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.pwdData = (res && res.content) || {}
        state.psStatus = state.status > -9999 && 'stated'
    },

    [type.CHANGEPAYPWD_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.cPwdData = {}
        state.cpStatus = 'stating'
    },
    [type.CHANGEPAYPWD_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.cPwdData = (res && res.content) || {}
        state.cpStatus = state.status > -9999 && 'stated'
    },

    [type.GETUSERPAYEMAIL_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.peData = {}
        state.peStatus = 'stating'
    },
    [type.GETUSERPAYEMAIL_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.peData = (res && res.content) || {}
        state.peStatus = state.status > -9999 && 'stated'
    },

    [type.CHECKPAYPWD_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.checkData = {}
        state.checkStatus = 'stating'
    },
    [type.CHECKPAYPWD_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.checkData = (res && res.content) || {}
        state.checkStatus = state.status > -9999 && 'stated'
    },

    [type.CHECKUPAY_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.checkUPData = {}
        state.checkUPStatus = 'stating'
    },
    [type.CHECKUPAY_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.checkUPData = (res && res.content) || {}
        state.checkUPStatus = state.status > -9999 && 'stated'
    },

    [type.GETVERSION_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.versionData = {}
        state.vLoading = 'stating'
    },
    [type.GETVERSION_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.versionData = (res && res.content) || {}
        state.vLoading = state.status > -9999 && 'stated'
    },
    // center 模块 ParamTrackerCtrl 
    [type.TRACKLOG_REQUEST](state) {
        state.trackLogStatus = 'loading';
        state.trackLogInfo = {};
    },
    [type.TRACKLOG_RECEIVE](state, res) {
        state.trackLogStatus = 'loaded';
        state.trackLogInfo = res?.content || {};
    },
}